import styled from 'styled-components';

import type { ReactNode, FC } from 'react';

type Location = 'footer' | 'mobile';
interface GroupProps {
  location: Location;
}

const Group = styled.div<GroupProps>`
  position: relative;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
`;

interface LinkGroupProps {
  children: ReactNode;
  location: Location;
}

export const LinkGroup: FC<LinkGroupProps> = ({ children, location }) => (
  <Group location={location}>
    <Grid>{children}</Grid>
  </Group>
);
